import {
  asUrl,
  getThingAll,
  getUrl,
  SolidDataset,
  Thing,
  ThingPersisted,
} from '@inrupt/solid-client'
import { URI } from '../utils/ontology'
import { checkType } from './utils'

export class Survey {
  private _thing: ThingPersisted

  static fromDataset(dataset: SolidDataset): Survey | undefined {
    const things = getThingAll(dataset)
    const surveyThing = things.find(
      t => getUrl(t, URI.TYPE_PREDICATE) === URI.SURVEY_CLASS
    )
    if (!surveyThing) {
      return undefined
    }
    return new Survey(surveyThing as ThingPersisted)
  }

  constructor(thing: ThingPersisted) {
    checkType(thing, URI.SURVEY_CLASS)
    this._thing = thing
  }

  get url(): string {
    return asUrl(this._thing)
  }

  get thing(): Thing {
    return this._thing
  }

  get startsWith(): string | undefined {
    return getUrl(this._thing, URI.SURVEY_STARTS_WITH_PREDICATE) || undefined
  }
}
